export
default {
	common:
	{
	    langEn: 'English',     
	    langZh: '简体中文',       
	    langFt: '繁體中文',      
	    langMl: 'Bahasa Melayu', 
	    langYn: 'Tiếng Việt',   
	    langJa: '日本語',         
	    langKr: '한국어',       
	    langFa: 'Français',    
	    langTr: 'Türkçe',     
	    langYin: 'Bahasa Indonesia', 
	    langEs: 'Español'   
	},
	"home": {
		"h1": "MetaMask仮想通貨",
		"h1B": "MetaMask仮想通貨銀行",
		"h1C": "DeFiウォレット仮想通貨",
		"h1D": "Coinbase仮想通貨銀行",
		"h1E": "MetaMask貯蓄銀行",
		"h1F": "Zerion暗号資産",
		"h2": "友達を招待",
		"h3": "出金口座",
		"h4": "貯蓄に参加",
		"h4B": "仮想通貨入金",
		"h4C": "デジタル通貨入金",
		"h5": "おすすめ資産運用",
		"h5B": "秒契約取引",
		"h6": "ユーザープール",
		"h7": "USDT口座",
		"h8": "総収益",
		"h9": "有効ノード",
		"h10": "参加者",
		"h11": "収益",
		"h12": "収益記録",
		"h13": "アドレス",
		"h14": "預金増加数",
		"h15": "よくある質問",
		"h16": "参加方法は？",
		"h17": "ユーザー各位、USDTウォレット貯蓄に参加ご希望の場合は、プラットフォームの利用規約を遵守し、プラットフォームの決定を厳格に実行し、リスク部門の監督を受けて頂く必要があります。これにより自動的に入金権限が付与されます。ご参加お待ちしております。",
		"h17B": "ユーザー各位、USDTウォレット貯蓄に参加ご希望の場合は、プラットフォームの利用規約を遵守し、プラットフォームの決定を厳格に実行し、リスク部門の監督を受けて頂く必要があります。これにより自動的に入金権限が付与されます。ご参加お待ちしております。",
		"h18": "出金手続きについて",
		"h19": "日々の収益は自動的に口座残高に加算されます。USDT出金成功後はUSDTウォレットに自動反映されます。",
		"h19B": "「出金」オプションをクリックしてください。\n直接USDTでの出金をご希望の場合は、正確なウォレットア ドレスをご入力ください。\n法定通貨での出金をご希望の場合は、該当国の銀行口座を選択し、銀行口座情報をご入力ください。\n必要情報の入力が完了したら、出金希望金額を入力し、1~24時間以内にご指定の口座に反映されます。",
		"h20": "収益はどう計算されますか？",
		"h21B": "登録が完了すると、貯蓄口座の利息計算が開始されます\n貯蓄額が1$〜500$の場合、0.5%の利息が得られます\n貯蓄額が500$以上の場合、0.6%の利息が得られます\n貯蓄額が1000$以上の場合、0.7%の利息が得られます\n貯蓄額が2000$以上の場合、0.8%の利息が得られます\n貯蓄額が3000$以上の場合、0.9%の利息が得られます\n貯蓄額が5000$以上の場合、1%の利息が得られます",
		"h21": "参加後、貯蓄契約が収益計算を開始します。",
		"h22": "貯蓄収益の源泉は？",
		"h23": "参加後、貯蓄契約が発効します。利子は1日4回（00:00, 06:00, 12:00, 18:00）に決済されます。資金はエスクローされ、プラットフォームが保安を担当します。規則遵守の上、問題はカスタマーサービスへ。",
		"h23B": "ユーザー様が貯蓄にご参加いただくと、貯蓄契約が有効となり、ユーザー様は 00:00、06:00、12:00、18:00 の1日4回、利息の決済をお受け取りいただけます。\n貯蓄契約が発効いたしますと、ユーザー様のご資金は保管モードに移行し、当プラットフォームが資金の安全を責任をもって管理いたします。\nユーザー様のアカウント資金の安全を確保するため、必ず当プラットフォームのルールを厳守いただきますようお願い申し上げます。\n万が一問題が発生した場合は、オンラインカスタマーサービスセンターまでご連絡ください。",
		"h24": "ボーナスは？",
		"h25": "友達を招待できます。招待した友達が参加すると、初回入金額の20%の紹介報酬と、その後の収益の10%の永久手数料を得られます。招待リンクはホーム右上にあります。",
		"h25B": "本プラットフォームを友達に共有できます。友達が参加すると、初回入金額の20%の紹介報酬と、その後の収益の10%の永久手数料を得られます。招待リンクはホーム右上にあります。",
		"h26": "口座",
		"h27": "総収入",
		"h88": "プラットフォーム背景",
		"h89": "USDT\n設立: 2008年\n本社: アメリカ紐約\n事業: ロボアドバイザーとフィンテック、自動投資ポートフォリオと現金管理\n規制: SECの監督、FINRAメンバー\n規模: 資産運用額400億ドル超\n顧客: 個人・法人80万人以上",
		"h90": "プラットフォーム強み",
		"h91": "✔️ アメリカ初のロボアドバイザーの一つ、経験豊富\n✔️ 現代ポートフォリオ理論に基づくリスク分散\n✔️ 税制最適化機能\n✔️ 高金利現金口座、流動性高い\n✔️ 完全デジタル操作、シンプルな界面",
		"h92": "こんな方に",
		"h93": "★ 頻繁な取引なしで長期安定投資をしたい方\n★ 自動資産管理で手間を省きたい若い投資家\n★ 投資＋高金利貯蓄＋退職口座を求めている方\n★ 低コストで市場に入りたい一般投資家",
		"h94": "ボーナスはいくら？",
		"h95": "友達とプラットフォームを共有できます。参加すると、初回入金額の20%の紹介ボーナスと、収益の10%の紹介手数料を得られます。共有リンクはホーム右上にあります。",
		"h96": "コピー",
		"h97": "招待リンク",
		"h98": "コピー成功",
		"h99": "コピー失敗",
		"h28": "本日収益",
		"h29": "資産運用収益",
		"h30": "出金",
		"h31": "記録",
		"h32": "利用可能残高",
		"h33": "出金額",
		"h34": "出金額を入力",
		"h35": "すべて",
		"h36": "出金",
		"h37": "よくある質問",
		"h38": "セキュリティ監査報告書あり",
		"h39": "パートナー",
		"h40": "業務提携先",
		"h41": "銀行カード番号表示",
		"h42": "前へ",
		"h43": "次へ",
		"h44": "最初のページです",
		"h45": "出金額を入力してください",
		"h46": "残高不足",
		"h47": "最後のページです",
		"h48": "収入",
		"h49": "支出",
		"h50": "操作が頻繁です。しばらくしてから再試行してください。",
		"h51": "監査報告書",
		"h52": "預けて利子を得る",
		"h53": "注文取引",
		"h54": "登録ボーナス",
		"h55": "招待ボーナス",
		"h56": "出金",
		"h57": "入金",
		"h58": "預入",
		"h59": "引出",
		"h60": "私たちについて",
		"h61": "MetaMask銀行を支援頂くユーザーの皆様へ。貯蓄をより簡単に、暗号資産(USDT, ETH, BTC)送金でボーナス獲得。1000USDT以上入金で30USDT、5000USDT以上で200USDT、10000USDT以上で金額の5%ボーナス。（暗号資産ウォレット出金も同様）",
		"h61B": "Coinbase銀行を支援頂くユーザーの皆様へ。貯蓄をより簡単に、暗号資産(USDT, ETH, BTC)送金でボーナス獲得。1000USDT以上入金で30USDT、5000USDT以上で200USDT、10000USDT以上で金額の5%ボーナス。",
		"h61C": "MetaMask銀行を支援頂くユーザーの皆様へ。貯蓄をより簡単に、暗号資産(USDT, ETH, BTC)送金でボーナス獲得。1000USDT以上入金で30USDT、5000USDT以上で200USDT、10000USDT以上で金額の5%ボーナス。",
		"h61D": "USDTは2017年より、誰であっても、どこにいても、ブロックチェーン資産へのアクセスを簡素化することで、より高い財務的自由を実現できるよう支援してきました。"
	},
	"bankcard": {
		"b1": "銀行口座",
		"b2": "金融機関",
		"b3": "金融機関を入力",
		"b4": "支店名",
		"b5": "支店名を入力",
		"b6": "支店番号",
		"b7": "支店番号を入力",
		"b8": "口座番号",
		"b9": "口座番号を入力",
		"b10": "表示名",
		"b11": "ユーザー名を入力",
		"b12": "口座名義(カタカナ)",
		"b13": "口座名義人を入力",
		"b14": "設定を保存"
	},
	"usdt": {
		"u1": "私の注文",
		"u2": "購入",
		"u3": "契約時間を選択：",
		"u4": "購入価格：",
		"u5": "購入金額を入力",
		"u6": "買い",
		"u7": "売り",
		"u8": "操作成功",
		"u9": "最低 ",
		"u10": "超過",
		"u11": "金額はより大きく",
		"u12": "金額はより小さく",
		"u13": "手数料残高不足",
		"u14": "決済完了",
		"u15": "現在の価格",
		"u17": "方向",
		"u19": "手数料"
	},
	"order": {
		"o0": "私の注文",
		"o1": "注文番号",
		"o2": "注文タイプ",
		"o3": "購入金額",
		"o4": "売却金額",
		"o5": "支払金額",
		"o6": "契約時間",
		"o7": "注文状況",
		"o8": "決済状況",
		"o9": "決済時間",
		"o10": "注文時間",
		"o11": "買い",
		"o12": "売り",
		"o13": "売却済",
		"o14": "利益",
		"o15": "損失",
		"o16": "支払済",
		"o17": "損益分岐点"
	},
	"recharge": {
		"r1": "入金額",
		"r2": "入金額",
		"r3": "入金タイプ",
		"r4": "選択",
		"r5": "入金アドレス",
		"r6": "振替取引ID",
		"r7": "振替済",
		"r8": "審査中",
		"r9": "入力誤り",
		"r10": "支払方法を選択",
		"r11": "最低入金額は",
		"r12": "入金上限額は",
		"r13": "金額を入力",
		"r14": "支払スクリーンショットをアップロード",
		"r15": "支払スクリーンショットをアップロードしてください",
		"r16": "引き出し成功"
	},
	"rechargeDetails": {
		"r1": "入金記録",
		"r2": "入金額",
		"r3": "審査中",
		"r4": "入金成功",
		"r5": "入金失敗"
	},
	"new": {
		"h70": "数量",
		"h71": "タイプ",
		"h72": "時間",
		"h80": "銀行カードのお引き出し",
		"h81": "暗号通貨のお引き出し",
		"h82": "出金アドレスを入力",
		"h83": "出金数量を入力",
		"h84": "出金タイプを選択",
		"h85": "取引情報",
		"h86": "最小出金額",
		"h87": "手数料",
		"h88": "到着予定",
		"h89": "引き出し",
		"h90": "マイ一銀行カ一ド",
		"h91": "銀行カード変更",
		"h910": "まず銀行カードを紐付けてください",
		"h911": "銀行口座の設定",
		"h92": "キャンセル",
		"h93": "確認",
		"h94": "名称",
		"h95": "価格",
		"h96": "上昇率",
		"h97": "出金額入力誤り",
		"h98": "さらに表示",
		"h99": "仕訳記録",
		"h60": "出金成功",
		"h61": "出金失敗",
		"h62": "コピー成功",
		"h63": "通貨",
		"h50": "PayPay出金",
		"h51": "PayPay ID入力",
		"h52": "電話番号入力",
		"h53": "PayPay QRコードアップロード",
		"h54": "チャネルを選択 ",
		"h55": "入金ネットワーク",
		 "h56": "出金情報を再確認する",
		  "h57": "PayPay ID",
		  "h58": "電話番号",
		  "h59": "口座変動額"
	},
	"api": {
		"提现超过限制次数": "引き出し限度額を超えています",
		"两次提现间隔时间不得少于1小时": "出金間隔は1時間以上空けてください",
		"提现超过限制次数": "出金限度額を超えました",
		"提现申请": "出金申請",
		"提现金额未配置": "出金額未設定",
		"禁止登录": "ログイン禁止",
		"您存在多笔待处理提现订单": "処理待ちの出金注文が複数あります",
		"低于最低提现额度": "最低出金額未満",
		"提现超过限制": "出金制限超過",
		"请先绑定提现账号": "まず出金口座を紐付けてください",
		"処理": "処理",
		"银行不存在": "銀行が存在しません",
		"处理中": "処理中",
		"订单交易": "注文取引",
		"邀请奖励": "招待報酬",
		"秒合约订单结算": "秒契約注文決済",
		"获取火币行情失败": "Huobi相場取得失敗",
		"用户数据不存在": "ユーザーデータが存在しません",
		"没有此账号": "アカウントが存在しません",
		"邀请码不存在": "招待コードが存在しません",
		"注册奖励": "新規ユーザー登録ボーナス",
		"用户提现": "ユーザー出金",
		"失败请重试": "失敗しました。再試行してください",
		"请不要重复提交": "重複引き出しはご遠慮ください",
		"用户名或密码错误": "ユーザー名またはパスワードが間違っています",
		"密码不能为空": "パスワードは必須です",
		"用户名已存在": "ユーザー名は既に存在します",
		"用户名长度在4到12位之间": "ユーザー名は4〜12文字で入力してください",
		"密码格式为任意可见字符，长度在6~18之间": "パスワードは任意の表示可能文字、長さ6〜18文字",
		"密码错误次数太多": "パスワード誤り回数が多すぎます",
		"旧密码不正确": "旧パスワードが正しくありません",
		"昵称不能为空": "ニックネームは必須です",
		"允许的最长字符为16": "最大文字数は16文字です",
		"图片不能为空": "画像は必須です",
		"用户不存在": "ユーザーが存在しません",
		"用户余额错误": "ユーザー残高エラー",
		"手机区号错误": "携帯電話市外局番エラー",
		"手机号长度最小5位数": "携帯電話番号は最低5桁です",
		"手机号不能为空": "携帯電話番号は必須です",
		"验证码错误": "確認コードエラー",
		"充值通道已关闭": "入金チャネル閉鎖",
		"充值金额不正确": "入金額が正しくありません",
		"最低充值额度100USDT": "最低入金額100USDT",
		"提现通道已关闭": "出金チャネル閉鎖",
		"提现金额不正确": "出金額が正しくありません",
		"请先绑定提现账号": "まず出金口座を紐付けてください",
		"低于最低提现额度": "最低出金額未満",
		"您已绑定过银行卡": "銀行カードは既に紐付け済みです",
		"两次提现间隔时间不得少于1小时": "出金間隔は1時間以上空けてください",
		"登陆失败": "ログイン失敗",
		"秒合约订单结算": "秒契約注文決済",
		"秒合约下单手续费": "秒契約注文手数料",
		"存币生息": "預けて利子を得る",
		"充值": "本日の預金",
		"提现": "出金",
		"上分": "本日の預金",
		"下分": "本日の引き出し",
		"存在未完成的提现订单":"未処理の出金申請があります。1分後に再度お試しください。",
		"两次提现间隔时间不得少于1分钟":"2 回の引き出しの間隔は 1 分以上である必要があります。",
		"赠送": "VIPボーナス贈呈",
	},
	chat: {
		title: "オンラインカスタマーサービス",
		input: "メッセージを入力...",
		send: "送信",
		empty: "メッセージはありません。ご質問はこちらへ",
		loginFirst: "先にウォレットを接続してログインしてください",
		sendFail: "送信に失敗しました",
		uploading: "画像をアップロード中",
		uploadFail: "画像のアップロードに失敗しました"
	}
}